import { store } from "../store";
import {
  SET_PROFILE_CHOOSEN,
  SET_USER_PROFILE,
  SET_PROFILE_IMAGE,
  SET_ACCESS_LIST,
  SET_ROLE_PERMISSION,
} from "../store/constants";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";
import * as CryptoJS from "crypto-js";
import { CONFIG } from "../environment";

const GCM_SECRET_KEY = CryptoJS.enc.Utf8.parse(CONFIG.GCM_KEY);
const AES_SECRET_KEY = CryptoJS.enc.Utf8.parse(CONFIG.ENCRYPT_KEY);

export const encryptAES = (text) =>
  CryptoJS.AES.encrypt(text, AES_SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

const fetchProfileDetails = async (data) => {
  try {
    const reqParams = {
      requestId: "USERPROFILE",
      module: "PROFILE",
      ...data,
    };
    const response = await http.post(API_CONFIG.profileDetails, reqParams);
    if (response.status === 200) {
      store.dispatch({
        type: SET_USER_PROFILE,
        payload: response.data["customerDetails"] || {},
      });
      store.dispatch({
        type: SET_PROFILE_IMAGE,
        payload: response.data["customerDetails"]["photo"],
      });
      store.dispatch({
        type: SET_ACCESS_LIST,
        payload: response.data["customerDetails"]?.acccessList || {},
      });

      store.dispatch({
        type: SET_ROLE_PERMISSION,
        payload:
          Object.keys(response.data["customerDetails"]?.acccessList || {})
            .length > 0
            ? Object.keys(response.data["customerDetails"]?.acccessList)[0]
            : "AA",
      });
    }
    return {
      status: response.status,
      data: response.data["customerDetails"] || {},
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const setQestions = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "SECURITYQUESTATIONS",
      // module: "INFO",
      // profileId: parseInt(profileDetails["profileId"] || 0),
      securityQuestions: [...data],
    };
    const response = await http.post(API_CONFIG.setQestions, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const setQestionsSkip = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "SECURITYQUESTATIONS",
      module: "SECURITYQUESTATIONS",
      // profileId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.setQestionsSkip, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getQestionsAndAnswer = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "SECURITYQUESTATIONS",
      module: "SECURITYQUESTATIONS",
      // profileId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getQestionsAndAnswer,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getSecurityQuestions = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "SECURITYQUESTATIONS",
      module: "SECURITYQUESTATIONS",
      // profileId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getSecurityQuestions,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const upComingInComing = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "UPCOMINGINCOMING",
      module: "UPCOMINGINCOMING",
      noOfDays: "31",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.upComingInComing, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const upComingPayments = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "UP_CMG_PAYMENTS",
      noOfDays: "31",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.upComingPayments, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const emailUpdate = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "email_update",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.emailUpdate, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const changePasswordVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      currentPassword: encryptAES(data.currentPassword),
      newPassword: encryptAES(data.newPassword),
      requestId: "FORCECHANGEPWD",
      module: "REGISTRATION",
    };
    const response = await http.post(
      API_CONFIG.changePasswordVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const changePassword = async (data) => {
  try {
    const reqParams = {
      ...data,
      currentPassword: encryptAES(data.currentPassword),
      newPassword: encryptAES(data.newPassword),
      requestId: "FORCECHANGEPWD",
      module: "REGISTRATION",
    };
    const response = await http.post(API_CONFIG.changePasswrod, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};
const getMyActivity = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      requestId: "MY_ACTIVITY",
    };
    const response = await http.post(API_CONFIG.getMyActivity, reqParams);

    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const editProfileImage = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "UPDATEPROFILEIMAGE",
      module: "PROFILE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.editProfileImage, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteProfileImage = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DELETEPROFILEIMAGE",
      module: "PROFILE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.deleteProfileImage, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getMenuPermissionDetails = async (data="") => {
  try {
    const { app } = store.getState();
    const { accessList, mode } = app;

    const menuDetails = accessList[mode].filter((ele) =>
      data.includes(ele.screenCode)
    );

    return { status: 200, data: menuDetails || [] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const ProfileService = {
  fetchProfileDetails,
  setQestionsSkip,
  getQestionsAndAnswer,
  setQestions,
  upComingPayments,
  upComingInComing,
  emailUpdate,
  changePasswordVerify,
  changePassword,
  getMyActivity,
  editProfileImage,
  deleteProfileImage,
  getSecurityQuestions,
  getMenuPermissionDetails,
};

export default ProfileService;
